import { render, staticRenderFns } from "./AdvancedReview.vue?vue&type=template&id=5c97f47a&"
import script from "./AdvancedReview.vue?vue&type=script&lang=js&"
export * from "./AdvancedReview.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c97f47a')) {
      api.createRecord('5c97f47a', component.options)
    } else {
      api.reload('5c97f47a', component.options)
    }
    module.hot.accept("./AdvancedReview.vue?vue&type=template&id=5c97f47a&", function () {
      api.rerender('5c97f47a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/AdvancedReview.vue"
export default component.exports